import React from 'react';
import './index.scss';

const Loading: React.FC = () => {
	return <div className="loading">
		加载中...
	</div>
}

export default Loading;
